module.exports = __webpack_public_path__ + "static/media/morion-bold.332ab69e.woff2";